import React, { useState } from 'react'
import styled from 'styled-components'
import { Modal, IconButton } from '@material-ui/core'
import prooSrc from '../assets/promo.jpg'
import { Close } from '@material-ui/icons'

const ModalStyled = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;
`
const Picture = styled.img`
  width: 100%;
`

const Contaiiner = styled.div`
  position: relative;
  width: 90%;
  max-width: 500px;
  @media screen and (max-width:1600px) {
    max-width: 400px;
  }
  @media screen and (max-width:1200px) {
    max-width: 350px;
  }
`
const ButtonClose = styled(IconButton)`
  position: absolute;
  right: 10px;
  top: 10px;
  @media screen and (max-width:800px) {
    right: 5px;
    top: 5px;
  }
`

const Promo = props => {
  const [isPromoOpen, setOpen] = useState(false)
  const currentDate = new Date()
  const limitPromo = new Date('2020-10-1')

  if (currentDate >= limitPromo) return null

  return (
    <ModalStyled open={isPromoOpen} onClose={event => setOpen(false)}>
      <Contaiiner>
        <ButtonClose size='small' onClick={event => setOpen(false)}>
          <Close />
        </ButtonClose>
        <Picture src={prooSrc} />
      </Contaiiner>
    </ModalStyled>
  )
}

export default Promo
